var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.fullscreenVisible)?_c('div',{class:_vm.classes},[_c('div',{class:_vm.mainClasses},[_c('span',{class:_vm.dotClasses}),_vm._v(" "),_c('div',{class:_vm.textClasses},[_vm._t("default")],2)])]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/spin/spin.vue